import { paginatorRoute } from '@api/paginator';
import {
    Dispatch,
    SetStateAction,
    useEffect,
    useState,
} from 'react';
import { useQuery } from 'react-query';

import {
    getThreadRoute,
    messagesKey,
    errorMessage,
    Thread,
    Message,
} from '@features/messaging';
import axiosInstance from '@server/axiosInstance';

type useGetRockerboxThreadProps = {
    threadId?: number;
    companyId?: number;
    setErrorText?: Dispatch<SetStateAction<string>>;
    threadPage?: number;
};

export const useGetRockerboxThread = ({
    threadId,
    companyId,
    setErrorText = () => { },
    threadPage = 1,
}: useGetRockerboxThreadProps): {
    messages: Message[] | undefined;
    thread: Thread | null;
    isLoadingThread: boolean;
} => {
    const [thread, setThread] = useState<Thread | null>(null);
    const [stateThreadId, setStateThreadId] = useState<number | undefined>(
        threadId,
    );
    const [messages, setMessages] = useState<Message[]>([]);

    const { isLoading: isLoadingThread } = useQuery({
        queryKey: [messagesKey, stateThreadId, companyId, threadPage],
        // enabled: Boolean(threadId),
        queryFn: () => {
            const params = new URLSearchParams();

            if (threadPage > 1) {
                params.append('page', String(threadPage));
                params.append('cache', 'messages');
            }

            if (stateThreadId) {
                params.append('thread_id', String(stateThreadId));
            } else if (companyId) {
                params.append('company_id', String(companyId));
                params.append('rockerbox', String(true));
            }

            const requestUrl = threadPage === 1 ? getThreadRoute : paginatorRoute;

            return axiosInstance.get(requestUrl, { params }).then((res) => res.data);
        },

        onSuccess: (data) => {
            if (data.object2) {
                setErrorText('');
                setStateThreadId(data.object2?.id);
                setThread(data.object2);
            }
            if (data.status === 205) {
            } else {
                if (data?.object?.length && threadPage > 1) {
                    setMessages((prev) => [...prev, ...(data.object as Message[])]);
                } else {
                    setMessages(data.object as Message[]);
                }
            }
        },
        onError: () => {
            setErrorText(errorMessage);
        },
        refetchInterval: 5000,
    });


    useEffect(() => {
        setStateThreadId(threadId);
    }, [threadId]);

    useEffect(() => {
        if (threadPage === 1) {
            setMessages([]);
        }
    }, [threadPage]);

    return {
        isLoadingThread,
        thread,
        messages: messages && messages.sort(
            (a, b) =>
                new Date(a.dt_timestamp).getTime() - new Date(b.dt_timestamp).getTime(),
        ),
    };
};
